import { render, staticRenderFns } from "./ProReviewDialog.vue?vue&type=template&id=d50e08da&"
import script from "./ProReviewDialog.vue?vue&type=script&lang=js&"
export * from "./ProReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProReviewDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports